export enum LanguageLevelEnum {
  FIRST_LANGUAGE = "FIRST_LANGUAGE",
  FLUENT = "FLUENT",
  MODERATE = "MODERATE",
  BEGINNER = "BEGINNER"
}
